<footer class="footer">
  <div class="footer-main">
    <div class="container">
      <div class="row g-4">
        <!-- Company Info -->
        <div class="col-lg-4 col-md-6">
          <div class="footer-section">
            <div class="footer-brand mb-4">
              <app-logo size="medium" [showText]="true" [showTagline]="true"></app-logo>
            </div>
            <p class="footer-description">
              Your trusted partner in certification success. Join thousands of professionals who've passed their exams with our comprehensive practice tests and expert guidance.
            </p>
            <div class="social-links">
              <a href="#" class="social-link" title="Follow us on Twitter">
                <i class="bi bi-twitter"></i>
              </a>
              <a href="#" class="social-link" title="Follow us on LinkedIn">
                <i class="bi bi-linkedin"></i>
              </a>
              <a href="#" class="social-link" title="Follow us on Facebook">
                <i class="bi bi-facebook"></i>
              </a>
              <a href="#" class="social-link" title="Follow us on Instagram">
                <i class="bi bi-instagram"></i>
              </a>
            </div>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="col-lg-2 col-md-6">
          <div class="footer-section">
            <h5 class="footer-title">Quick Links</h5>
            <ul class="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/certifications">Certifications</a></li>
              <li><a href="/pricing">Pricing</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
        </div>

        <!-- Certifications -->
        <div class="col-lg-2 col-md-6">
          <div class="footer-section">
            <h5 class="footer-title">Certifications</h5>
            <ul class="footer-links">
              <li><a href="/certifications/aws">AWS</a></li>
              <li><a href="/certifications/azure">Microsoft Azure</a></li>
              <li><a href="/certifications/gcp">Google Cloud</a></li>
              <li><a href="/certifications/kubernetes">Kubernetes</a></li>
              <li><a href="/certifications/docker">Docker</a></li>
            </ul>
          </div>
        </div>

        <!-- Support -->
        <div class="col-lg-2 col-md-6">
          <div class="footer-section">
            <h5 class="footer-title">Support</h5>
            <ul class="footer-links">
              <li><a href="/help">Help Center</a></li>
              <li><a href="/faq">FAQ</a></li>
              <li><a href="/contact">Contact Support</a></li>
              <li><a href="/feedback">Feedback</a></li>
              <li><a href="/status">System Status</a></li>
            </ul>
          </div>
        </div>

        <!-- Newsletter -->
        <div class="col-lg-2 col-md-6">
          <div class="footer-section">
            <h5 class="footer-title">Stay Updated</h5>
            <p class="newsletter-text">Get the latest updates and tips for your certification journey.</p>
            <div class="newsletter-form">
              <div class="input-group">
                <input type="email" class="form-control" placeholder="Your email" aria-label="Email address">
                <button class="btn btn-primary" type="button">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Bottom -->
  <div class="footer-bottom">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <p class="copyright">
            &copy; 2025 ExamAlly. All rights reserved.
          </p>
        </div>
        <div class="col-md-6 text-md-end">
          <div class="footer-bottom-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/cookies">Cookie Policy</a>
            <button 
              type="button" 
              class="cookie-preferences-btn" 
              (click)="openCookiePreferences()"
              aria-label="Manage cookie preferences">
              Cookie Preferences
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<!-- Cookie Preferences Modal -->
<app-cookie-preferences-modal 
  [isOpen]="showCookiePreferences"
  (closeEvent)="closeCookiePreferences()">
</app-cookie-preferences-modal>